<template>
  <div class="play">
    <!-- img alt="Vue logo" src="../assets/logo.png" / -->
    <!-- div class="opaque"></div -->
    <Droopy />
  </div>
</template>

<script>
// @ is an alias to /src
import Droopy from "@/components/Droopy.vue";

export default {
  name: "Play",
  components: {
    Droopy
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.play {
  display: flex;
  flex: 1;
  min-height: 0;
  position: relative;
}

.droopy {
  position: relative;
  z-index: 2;
}
/* .opaque { */
.play::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url("../assets/background-images/northern-lights-by-boat_iceland.jpg")
    no-repeat center fixed;
  background-size: cover;
  opacity: 0.85;
  z-index: 1;
}
/* https://css-tricks.com/snippets/css/complete-guide-grid */
</style>